module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-video"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "page-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "lines-wrapper"
  }, [_c('div', {
    ref: "lines1",
    staticClass: "lines1"
  }), _vm._v(" "), _c('div', {
    ref: "lines2",
    staticClass: "lines2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slideLeft"
    }
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnimate2),
      expression: "canAnimate2"
    }],
    staticClass: "title"
  }, [_vm._v("Смотри видеоотчеты")])])], 1), _vm._v(" "), (!_vm.Helpers.isTouch()) ? _c('ul', {
    staticClass: "video-list"
  }, _vm._l((_vm.weeks), function(item, key) {
    return _c('li', {
      staticClass: "video-item",
      class: {
        disabled: item.closed
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "video-preview",
      style: (("background-image: url(" + (item.closed ? '/static/img/video/lock.png' : item.preview) + ")"))
    }, [(!item.closed) ? _c('a', {
      staticClass: "play",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showVideo(item.video)
        }
      }
    }, [_c('play')], 1) : _vm._e()]), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "player",
      style: (("background-image: url(" + (item.player) + ")"))
    }) : _vm._e(), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "footballer",
      style: (("background-image: url(" + (item.footballer) + ")"))
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('h6', {
      staticClass: "text"
    }, [_vm._v(_vm._s(key + 1) + " неделя")])])])
  })) : _c('swiper', {
    ref: "mySwiper",
    staticClass: "video-list",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('arrow')], 1), _vm._v(" "), _vm._l((_vm.weeks), function(item, key) {
    return _c('swiper-slide', {
      key: key,
      class: {
        disabled: item.closed
      }
    }, [_c('div', {
      staticClass: "video-item"
    }, [_c('div', {
      staticClass: "item-content"
    }, [_vm._v("`\n\t\t\t\t\t\t"), _c('div', {
      staticClass: "video-preview",
      style: (("background-image: url(" + (item.closed ? '/static/img/video/lock.png' : item.preview) + ")"))
    }, [(!item.closed) ? _c('a', {
      staticClass: "play",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showVideo(item.video)
        }
      }
    }, [_c('play')], 1) : _vm._e()]), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "player",
      style: (("background-image: url(" + (item.player) + ")"))
    }) : _vm._e(), _vm._v(" "), (!item.closed) ? _c('div', {
      staticClass: "footballer",
      style: (("background-image: url(" + (item.footballer) + ")"))
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('h6', {
      staticClass: "text"
    }, [_vm._v(_vm._s(key + 1) + " неделя")])])])])
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83cbb2ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Video.vue
// module id = 509
// module chunks = 1